import React, { useState } from 'react';
import * as Yup from 'yup';
import { Formik, FormikHelpers } from 'formik';
import { Form, Input } from 'formik-antd';
import { useDispatch } from 'react-redux';
import { Button } from 'antd';

import FormItem from 'components/formik/FormItem';
import SubmitButton from 'components/formik/SubmitButton';
import { AppDispatch } from 'redux/store';
import { sendCallRequest } from 'redux/reducers/communicationSlice';

interface FormValues {
  name: string;
  email: string;
  phoneNumber: string;
}

const validationSchema = Yup.object({
  name: Yup.string()
    .trim()
    .required('Field is required')
    .max(120, 'Name should be 120 characters maximum'),
  email: Yup.string()
    .required('Field is required')
    .email('Email format is invalid')
    .max(120, 'Email should be 120 characters maximum'),
  phoneNumber: Yup.string()
    .trim()
    .required('Field is required')
    .max(120, 'Phone number should be 120 characters maximum'),
});

export default function ContactsSection() {
  const dispatch: AppDispatch = useDispatch();
  const initialValues: FormValues = { name: '', email: '', phoneNumber: '' };
  const [isRequestSent, setIsRequestSent] = useState(false);

  const handleSubmit = async (
    values: FormValues,
    formikHelpers: FormikHelpers<FormValues>,
  ) => {
    const result = await dispatch(sendCallRequest(values));

    if (sendCallRequest.fulfilled.match(result)) {
      setIsRequestSent(true);
      formikHelpers.resetForm();
    }
  };

  return (
    <section className="contact-main">
      <div className="wrapper container">
        <div className="contact-card">
          <div className="contact-card-wrapper">
            <div className="item-name">Contacts</div>

            <div>
              <ul>
                <li>
                  <a href="tel: 1 877 627 (MBP) 2021">1 877 627 (MBP) 2021</a>
                </li>
                <li>
                  <a href="mailto:info@mybasepay.com">info@mybasepay.com</a>
                </li>
              </ul>
            </div>

            <div className="item-name">Address</div>

            <div>
              <address>
                4301 S. Flamingo Road, Suite 106-228 <br />
                Davie, FL 33330
              </address>
            </div>
          </div>
        </div>

        <div className="form-wrapper">
          <div className="form-title">Let us call You</div>
          {isRequestSent && (
            <div className="form-popup corporate-success-popup">
              <div className="success-popup-content">
                <div className="success-popup__btn">
                  <Button type="link" onClick={() => setIsRequestSent(false)}>
                    <i className="icon icon-close"></i>
                  </Button>
                </div>
                <h2 className="success-popup__title">Thank you!</h2>
                <div className="success-popup__text">
                  We’ll get back to you as soon as possible. If you require
                  immediate assistance, please reach out via Live Chat.
                </div>
              </div>
            </div>
          )}

          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
          >
            <Form layout="vertical">
              <FormItem name="name" label="Your name" className="form-item">
                <Input
                  tabIndex={isRequestSent ? -1 : 0}
                  size="large"
                  name="name"
                />
              </FormItem>

              <FormItem name="email" label="Your email" className="form-item">
                <Input
                  tabIndex={isRequestSent ? -1 : 0}
                  size="large"
                  name="email"
                />
              </FormItem>

              <FormItem
                name="phoneNumber"
                label="Your phone number"
                className="form-item"
              >
                <Input
                  tabIndex={isRequestSent ? -1 : 0}
                  size="large"
                  name="phoneNumber"
                />
              </FormItem>

              <div className="form-btn">
                <SubmitButton
                  type="default"
                  size="large"
                  className="btn secondary-btn size-lg"
                  tabIndex={isRequestSent ? -1 : 0}
                >
                  Send request
                </SubmitButton>
              </div>
            </Form>
          </Formik>
        </div>
      </div>
    </section>
  );
}
